import React, { useEffect, useState, useRef } from "react";
import './projectdetail.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import anthelte1 from '../../../img/antheletmain.png'
import anthelte2 from '../../../img/anthelte-1.png'
import anthelte3  from '../../../img/anthelete-mobile1.png'
import anthelte4 from '../../../img/anthelete-mobile2.webp'
import anthelte5 from '../../../img/athelete1.png'
import anthelte6 from '../../../img/athelete2.png'
import anthelte7 from '../../../img/athelete3.png'
import anthelte8 from '../../../img/athelete4.png'
import anthelte9 from '../../../img/athelete5.png'


const containerVariants = {
   hidden: {},
   show: {
      transition: {
         staggerChildren: 0.3,  // Slight delay for each line to appear smoothly
      }
   }
};

const textVariants = {
   hidden: {
      opacity: 0,
      scale: 0.95,  // Starting slightly smaller for smooth zoom-in effect
      y: 30,         // Slightly moved down initially
      rotateX: 10,   // Rotation for a 3D effect
   },
   show: {
      opacity: 1,
      scale: 1,      // Final scale after animation
      y: 0,          // Final Y position (no vertical shift)
      rotateX: 0,    // Reset the rotation
      transition: {
         type: "spring",
         stiffness: 100,   // Increased stiffness for quicker snap
         damping: 22,      // Proper damping to smoothen stop
         duration: 1.1,    // Slightly slower duration for smooth entry
         ease: [0.25, 0.1, 0.25, 1]  // Custom easing for smooth animation
      }
   }
};

const Anthlete = () => {

   const [visible1, setVisible1] = useState(false); // FOOD ON TIPS
   const [visible2, setVisible2] = useState(false); // Challenges & Difficulties
   const [visible3, setVisible3] = useState(false); // Technologies Used
   const [visible4, setVisible4] = useState(false); // Key Features

   const heading1Ref = useRef();
   const heading2Ref = useRef();
   const heading3Ref = useRef();
   const heading4Ref = useRef();

   const letters1_line1 = ["A", "N", "T", "H", "L", "E", "T", "E"];
   const letters1_line2 = ["N", "U", "T", "R", "I", "T", "I", "O", "N"];
   const letters2_line1 = ["C", "h", "a", "l", "l", "e", "n", "g", "e", "s"];
   const letters2_line2 = ["&", " ", "D", "i", "f", "f", "i", "c", "u", "l", "t", "i", "e", "s"];
   const letters3_line1 = ["T", "e", "c", "h", "n", "o", "l", "o", "g", "i", "e", "s"];
   const letters3_line2 = ["U", "s", "e", "d"];
   const letters4_line1 = ["K", "e", "y", "\u00A0", "F", "e", "a", "t", "u", "r", "e", "s"];


   useEffect(() => {
      const observerOptions = { threshold: 0.3 };

      const createObserver = (setVisible, ref) => {
         const observer = new IntersectionObserver(
            ([entry]) => {
               if (entry.isIntersecting) {
                  setVisible(true);
                  observer.unobserve(ref.current);
               }
            },
            observerOptions
         );
         if (ref.current) observer.observe(ref.current);
      };

      createObserver(setVisible1, heading1Ref);
      createObserver(setVisible2, heading2Ref);
      createObserver(setVisible3, heading3Ref);
      createObserver(setVisible4, heading4Ref);

      return () => { }; // Cleanup skipped for simplicity
   }, []);

   // Animation Images 
   const imageRefs = useRef([]);

   const lerp = (start, end, factor) => {
      return start + (end - start) * factor;
   };

   const updatePosition = () => {
      imageRefs.current.forEach((img) => {
         if (img) {
            const speed = parseFloat(img.dataset.speed) || 0.8;
            const rect = img.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const elementOffsetTop = rect.top + scrollTop;
            const targetY = (scrollTop - elementOffsetTop) * speed;

            if (!img.currentY) img.currentY = 0;
            img.currentY = lerp(img.currentY, targetY, 0.1);

            img.style.transform = `translateY(${img.currentY}px)`;
            img.style.willChange = 'transform';
         }
      });
      requestAnimationFrame(updatePosition);
   };

   useEffect(() => {
      requestAnimationFrame(updatePosition);
   }, []);




   // animation Slider 

   const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      responsive: [
         {
            breakpoint: 768,
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,
            }
         }
      ]
   };

   const images = [
      anthelte5,
      anthelte6,
      anthelte6,
      anthelte7,
      anthelte8,
      anthelte9
     
   ];



   return (
      <div>
         {/* Aggressive mobile overflow fix: prevent any horizontal scroll on mobile */}
         <style>{`
           @media (max-width: 767px) {
             body {
               overflow-x: hidden !important;
               width: 100vw !important;
               position: relative !important;
             }
             html {
               overflow-x: hidden !important;
               width: 100vw !important;
             }
             #root, .App, .container, .container-1560 {
               overflow-x: hidden !important;
               width: 100vw !important;
               max-width: 100vw !important;
               position: relative !important;
            }
           }
         `}</style>
         {/* Responsive: break heading into 'ANTHLETE' and 'NUTRITION' lines on mobile */}
         <style>{`
           @media (max-width: 767px) {
             .tp-section-title-160 .word-break {
               display: block !important;
               width: 100%;
               height: 0;
             }
           }
         `}</style>
         <div id="smooth-wrapper">
            <div id="smooth-content">

               <main>

                  {/* <!-- project details area start --> */}

                  <div class="tp-project-details-3-top tp-project-details-3-ptb">
                     <div class="container container-1560">
                        <div class="row">
                           <div class="col-xl-12">
                              <div class="tp-project-details-3-title-box">
                                 {/* <h2 class="tp-section-title-160 mb-50 tp-char-animation">ANTHLETE NUTRITION</h2> */}
                                 <h2 ref={heading1Ref} className="tp-section-title-160 mb-50 tp-char-animation">
                                    <span style={{ display: "inline-block" }}>
                                       {letters1_line1.map((letter, index) => {
                                          let className = `char ${visible1 ? "visible" : ""}`;
                                          if (index === letters1_line1.length - 1) className += " word-break";
                                          return (
                                             <span
                                                key={`challenge1-${index}`}
                                                className={className}
                                                style={{ animationDelay: `${index * 0.1}s` }}
                                             >
                                                {letter}
                                             </span>
                                          );
                                       })}
                                    </span>
                                    <span style={{ display: "inline-block" }}>
                                       {letters1_line2.map((letter, index) => (
                                          <span
                                             key={`challenge2-${index}`}
                                             className={`char ${visible1 ? "visible" : ""}`}
                                             style={{ animationDelay: `${(letters1_line1.length + index) * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>
                                 </h2>
                                 <motion.div
                                    variants={containerVariants}
                                    initial="hidden"
                                    whileInView="show"
                                    viewport={{ once: true, amount: 0.2 }}
                                    className="space-y-4"
                                 >
                                    <motion.p variants={textVariants} className="project-text">
                                       Anthlete Nutritions is a modern e-commerce platform specializing in girls' <br />
                                       clothing and fashion. The goal was to create a seamless shopping experience <br />
                                       with an aesthetic UI, intuitive navigation, personalized recommendations, <br />
                                       and secure checkout. The website is designed to engage fashion-forward <br />
                                       customers, providing them with a fast, secure, and stylish shopping experience.
                                    </motion.p>
                                 </motion.div>

                              </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-xl-6">
                              <div class="tp-project-details-3-scroll smooth">
                                 <a href="#xyz">
                                    <span>
                                       <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M7.5 0L7.5 16.7586" stroke="currentcolor" stroke-width="1.5" stroke-miterlimit="10" />
                                          <path d="M0 10.1582C4.14553 10.1582 7.5 13.6652 7.5 17.9991" stroke="currentcolor" stroke-width="1.5" stroke-miterlimit="10" />
                                          <path d="M7.5 17.9991C7.5 13.6652 10.8545 10.1582 15 10.1582" stroke="currentcolor" stroke-width="1.5" stroke-miterlimit="10" />
                                       </svg>
                                    </span>
                                    Scroll to Explore
                                 </a>
                              </div>
                           </div>
                           <div class="col-xl-6">
                              <div class="tp-project-details-3-link mt-30 text-start text-md-end">
                                 <a href="https://anthletenutritions.com/">
                                    Visit  Website
                                    <span>
                                       <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1 9L9 1" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M1 1H9V9" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                       </svg>
                                    </span>
                                 </a>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  {/* <div class="tp-project-details-3-full-width-thumb mb-120 FOT-img">
               <img data-speed=".8" src="../img/anthelte.png" alt=""/>
            </div> */}
                  <div className="tp-project-details-3-full-width-thumb mb-120 FOT-img" style={{ overflow: 'hidden' }}>
                     <img
                        ref={(el) => (imageRefs.current[0] = el)}
                        data-speed=".8"
                        src={anthelte1}
                        alt=""
                        style={{ transform: 'translateY(0px)' }}
                     />
                  </div>

                  <div class="showcase-details-2-area pb-120">
                     <div class="container">
                        <div class="row">
                           <div class="col-xl-12">
                              <div class="showcase-details-2-section-box project-detail-heading">

                                 {/* <h4 class="showcase-details-2-section-title tp-char-animation">Challenges & Difficulties</h4> */}
                                 <h4 ref={heading2Ref} className="showcase-details-2-section-title tp-char-animation">
                                    <span style={{ display: "inline-block" }}>
                                       {letters2_line1.map((letter, index) => (
                                          <span
                                             key={`challenge1-${index}`}
                                             className={`char ${visible2 ? "visible" : ""}`}
                                             style={{ animationDelay: `${index * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>
                                    <br />
                                    <span style={{ display: "inline-block" }}>
                                       {letters2_line2.map((letter, index) => (
                                          <span
                                             key={`challenge2-${index}`}
                                             className={`char ${visible2 ? "visible" : ""}`}
                                             style={{ animationDelay: `${(letters2_line1.length + index) * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>
                                 </h4>
                              </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-xl-3">
                              <div class="showcase-details-2-section-left">
                                 <span class="ab-inner-subtitle mb-25">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M12 0C12 3.0432 9.53292 5.5102 6.48975 5.5102C6.48975 2.46701 8.95677 0 12 0Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M0.0231934 0.0231209C3.06639 0.0231209 5.5334 2.49015 5.5334 5.53333C2.4902 5.53333 0.0231934 3.0663 0.0231934 0.0231209Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M6.48975 6.4898C9.53294 6.4898 12 8.95682 12 12C8.95675 12 6.48975 9.53297 6.48975 6.4898Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M5.5102 6.48981C5.5102 9.533 3.04318 12 0 12C0 8.95681 2.46703 6.48981 5.5102 6.48981Z"
                                          fill="currentcolor" />
                                    </svg>
                                    An introduction
                                 </span>
                              </div>
                           </div>
                           <div class="col-xl-9">
                              <div class="showcase-details-2-content-right tp_title_anim project-detail-texts">
                                 <motion.div
                                    variants={containerVariants}
                                    initial="hidden"
                                    whileInView="show"
                                    viewport={{ once: true, amount: 0.2 }}
                                    className="space-y-4"
                                 >
                                    <motion.p variants={textVariants} className="project-text">
                                       Creating a Distinctive Brand Identity – The website needed a unique and fashion-forward look to stand out in the highly competitive women's fashion industry. <br />
                                       Performance Optimization – Ensuring fast load times and a lag-free experience even with high-resolution product images.
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-text">
                                       Seamless Shopping Experience – Reducing checkout abandonment through an intuitive UI and quick checkout options. <br />
                                       Secure Payment Gateway & Order Tracking – Ensuring end-to-end security for transactions and real-time tracking for customer orders.
                                    </motion.p>
                                 </motion.div>

                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div id="xyz" class="tp-project-details-3-thumb mb-120">
                     <div class="container container-1560">
                        <div class="row">
                           <div class="col-xl-12">
                              {/* <div class="tp-project-details-3-thumb-box">
                           <img data-speed=".8" class="w-100" src="./img/anthelte-1.png" alt=""/>
                        </div> */}
                              <div className="tp-project-details-3-thumb-box" style={{ overflow: 'hidden' }}>
                                 <img
                                    ref={(el) => (imageRefs.current[1] = el)}
                                    data-speed=".8"
                                    src={anthelte2}
                                    alt=""
                                    className="w-100"
                                    style={{ transform: 'translateY(0px)' }}
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div class="showcase-details-2-area pb-120">
                     <div class="container">
                        <div class="row">
                           <div class="col-xl-8">
                              <div class="showcase-details-2-section-box project-detail-heading">
                                 {/* <h4 class="showcase-details-2-section-title tp-char-animation">Technologies Used</h4> */}
                                 <h4 ref={heading3Ref} className="showcase-details-2-section-title tp-char-animation">
                                    <span style={{ display: "inline-block" }}>
                                       {letters3_line1.map((letter, index) => (
                                          <span
                                             key={`tech1-${index}`}
                                             className={`char ${visible3 ? "visible" : ""}`}
                                             style={{ animationDelay: `${index * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>
                                    <br />
                                    <span style={{ display: "inline-block" }}>
                                       {letters3_line2.map((letter, index) => (
                                          <span
                                             key={`tech2-${index}`}
                                             className={`char ${visible3 ? "visible" : ""}`}
                                             style={{ animationDelay: `${(letters3_line1.length + index) * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>
                                 </h4>
                              </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-xl-3">
                              <div class="showcase-details-2-section-left">
                                 <span class="ab-inner-subtitle mb-25">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M12 0C12 3.0432 9.53292 5.5102 6.48975 5.5102C6.48975 2.46701 8.95677 0 12 0Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M0.0231934 0.0231209C3.06639 0.0231209 5.5334 2.49015 5.5334 5.53333C2.4902 5.53333 0.0231934 3.0663 0.0231934 0.0231209Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M6.48975 6.4898C9.53294 6.4898 12 8.95682 12 12C8.95675 12 6.48975 9.53297 6.48975 6.4898Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M5.5102 6.48981C5.5102 9.533 3.04318 12 0 12C0 8.95681 2.46703 6.48981 5.5102 6.48981Z"
                                          fill="currentcolor" />
                                    </svg>
                                    An introduction
                                 </span>
                              </div>
                           </div>
                           <div class="col-xl-9">
                              <div class="showcase-details-2-content-right tp_title_anim project-detail-texts">
                                 {/* <!-- <p class="pb-25">Frontend:  React.js, Next.js (Web), Flutter/React Native (Mobile App)</p> --> */}
                                 <motion.div
                                    variants={containerVariants}
                                    initial="hidden"
                                    whileInView="show"
                                    viewport={{ once: true, amount: 0.2 }}
                                    className="space-y-4"
                                 >
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Frontend:</strong> React.js (Fast & dynamic UI), Bootstrap / Tailwind CSS (Stylish and responsive design)
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Backend:</strong> Node.js with Express.js (High-performance API)
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Database:</strong> MongoDB (Flexible and scalable database)
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Payment Integration:</strong> Razorpay, Stripe, PayPal, UPI, Apple Pay, Google Pay
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Cloud & Hosting:</strong> AWS / Firebase (Secure and scalable hosting)
                                    </motion.p>
                                 </motion.div>



                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div class="tp-project-details-3-thumb mb-90">
                     <div class="container">
                        <div class="row">
                           <div class="col-xl-6">
                              <div class="tp-project-details-3-thumb-box mb-30">
                                 <img class="w-100" src={anthelte3} alt="" />
                              </div>
                           </div>
                           <div class="col-xl-6">
                              <div class="tp-project-details-3-thumb-box mb-30">
                                 <img class="w-100" src={anthelte4} alt="" />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div class="showcase-details-2-area pb-120">
                     <div class="container">
                        <div class="row">
                           <div class="col-xl-8">
                              <div class="showcase-details-2-section-box project-detail-heading">
                                 {/* <h4 class="showcase-details-2-section-title tp-char-animation">Key Features</h4> */}
                                 <h4 ref={heading4Ref} className="showcase-details-2-section-title tp-char-animation">
                                    <span style={{ display: "inline-block" }}>
                                       {letters4_line1.map((letter, index) => (
                                          <span
                                             key={`feature1-${index}`}
                                             className={`char ${visible4 ? "visible" : ""}`}
                                             style={{ animationDelay: `${index * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>

                                 </h4>
                              </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-xl-3">
                              <div class="showcase-details-2-section-left">
                                 <span class="ab-inner-subtitle mb-25">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M12 0C12 3.0432 9.53292 5.5102 6.48975 5.5102C6.48975 2.46701 8.95677 0 12 0Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M0.0231934 0.0231209C3.06639 0.0231209 5.5334 2.49015 5.5334 5.53333C2.4902 5.53333 0.0231934 3.0663 0.0231934 0.0231209Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M6.48975 6.4898C9.53294 6.4898 12 8.95682 12 12C8.95675 12 6.48975 9.53297 6.48975 6.4898Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M5.5102 6.48981C5.5102 9.533 3.04318 12 0 12C0 8.95681 2.46703 6.48981 5.5102 6.48981Z"
                                          fill="currentcolor" />
                                    </svg>
                                    An introduction
                                 </span>
                              </div>
                           </div>
                           <div class="col-xl-9">
                              <div class="showcase-details-2-content-right tp_title_anim">
                                 {/* <!-- <p class="pb-25"> felt quite outdated and not in-line with the quality of his work. The main goal was to translate his high-end photography into a digital experience that would honor and present his work in a memorable and contemporary way.</p> --> */}
                                 <motion.div
                                    variants={containerVariants}
                                    initial="hidden"
                                    whileInView="show"
                                    viewport={{ once: true, amount: 0.2 }}
                                    className="space-y-4"
                                 >
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Elegant & Responsive UI</strong> – A modern, fashion-themed design optimized for all devices.
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>AI-Powered Product Recommendations</strong> – Smart suggestions based on shopping behavior.
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Wishlist & Favorites</strong> – Save items for later purchase.
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Multi-Payment Options</strong> – Credit/Debit Cards, UPI, Wallets, PayPal, and BNPL (Buy Now, Pay Later).
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Live Order Tracking</strong> – Real-time updates on order status.
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>One-Click Checkout</strong> – Streamlined checkout to improve conversion rates.
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>SEO & Social Media Integration</strong> – Optimized product pages and shareable links.
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Admin Dashboard for Inventory & Order Management</strong> – Easy control for website owners.
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>Multi-Language & Multi-Currency Support</strong> – Expanding global reach.
                                    </motion.p>
                                    <motion.p variants={textVariants} className="project-detail-text">
                                       <strong>User Reviews & Ratings</strong> – Enhancing trust and engagement.
                                    </motion.p>
                                 </motion.div>

                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="pd-visual-slider-wrap pb-40">
                     <div className="slider-container">
                        <Slider {...settings}>
                           {images.map((src, index) => (
                              <div key={index} className="image-wrapper">
                                 <div className="image-wrapper-inner">
                                    <img src={src} alt={`Slide ${index + 1}`} />
                                 </div>
                              </div>
                           ))}
                        </Slider>
                     </div>
                  </div>


               </main>


            </div>
         </div>
      </div>
   )
}

export default Anthlete